<app-field-container [field]="this">
  <div class="position-relative">
    <div class="search-container">
      <input
        type="search"
        [formControl]="searchControl"
        (keyup)="search($event)"
        class="form-control form-control-lg"
        [placeholder]="selectedLabel() ? '' : (placeholder() ?? '')" #inputElement/>
      <span class="search-icon">
        <lucide-icon [name]="icons.search"></lucide-icon>
      </span>
      @if (selectedLabel()) {
        <button type="button" class="btn btn-sm btn-outline-primary btn-clear" aria-label="Close" (click)="clear(inputElement)">
          {{ selectedLabel() }} <lucide-icon [name]="icons.close"></lucide-icon>
        </button>
      }
    </div>
    @if (showList()) {
      <div class="list-container position-absolute w-100">
        <ul class="list-group">
          @if (showSpinner()) {
            <li class="list-group-item">
              <div class="spinner-border text-tertiary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </li>
          } @else {
            @if (createChoiceLabel()) {
              <li class="list-group-item list-group-item-primary list-group-item-action" (click)="triggerCreate(inputElement)">
                <i>{{ createChoiceLabel() }}</i>
              </li>
            }
            @if (choices()) {
              @for (choice of choices(); track choice) {
                <li [title]="choice.hint ?? null" class="list-group-item list-group-item-primary list-group-item-action" (click)="select(choice, inputElement)">
                  @if (choice.icon) {
                    <lucide-icon [img]="choice.icon"></lucide-icon>
                  }
                  <span class="ms-2">{{ choice.text }}</span>
                </li>
              }
            }
          }
        </ul>
      </div>

    }
  </div>
</app-field-container>
